import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/eventPush/`,
		name: "添加事件转发",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/eventPush/`,
		name: "删除事件转发",
		delete: async function(id,data){
			return await http.delete(this.url+id+"/", data);
		}
	},
    detail: {
		url: `${config.API_URL}/eventPush/`,
		name: "查询事件转发详情",
		get: async function(id,data){
			return await http.get(this.url+id+"/", data);
		}
	},
    list: {
		url: `${config.API_URL}/eventPush/`,
		name: "查询事件转发列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    update: {
		url: `${config.API_URL}/eventPush/`,
		name: "修改事件转发",
		patch: async function(id,data){
			return await http.patch(this.url+id+"/", data);
		}
	},
}
